/**
 * @file 单选
 */
import './styles.less';
import Radio from 'antd/es/radio';
export { Radio };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvUmFkaW8vaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBRUgsT0FBTyxlQUFlLENBQUE7QUFFdEIsT0FBTyxLQUFxQixNQUFNLGVBQWUsQ0FBQTtBQUVqRCxPQUFPLEVBQUUsS0FBSyxFQUFFLENBQUEifQ==